import { connect } from 'react-redux';
import OpenOrder from '../components/exchange/OpenOrder';
import OpenOrderComponent from '../components/OpenOrderComponent';
import OrderHistoryComponent from '../components/OrderHistoryComponent';
import actions from '../redux/actions/order';
import orderBookAction from '../redux/actions/orderbook';
import consts from '../consts';
import actionsOrderTrans from '../redux/actions/order_transaction';

const mapStateToProps = (state) => ({
  order: state.order,
  orderBook: state.orderBook,
  user: state.user,
  setting: state.setting,
  mapCurrencyMarkets: state.setting.mapCurrencyMarkets,
  idOrderTransactions: state.orderTrans.idOrderTransactions,
});

const mapDispatchToProps = (dispatch) => ({
  onAddOrderAction: (params, callback) => {
    dispatch(actions.addOrderAction(params, callback));
  },
  onFetchOpenOrderAction: (params) => {
    dispatch(actions.fetchOpenOrderAction(params));
  },
  onFetchAllOrderAction: (params, callback = () => void (0)) => {
    dispatch(actions.fetchAllOrderAction(params, callback));
  },
  onFetchOrdersAction: (params, callback = () => void (0)) => {
    dispatch(actions.fetchOrdersAction(params, callback));
  },
  onFetchOpenOrdersPaginateAction: (params, callback = () => void (0)) => {
    dispatch(actions.fetchOpenOrdersPaginateAction(params, callback));
  },
  onFetchOrderAction: (params) => {
    dispatch(actions.fetchOrderAction(params));
  },
  onCancelOrderExchangeAction: (params, callback) => {
    dispatch(actions.cancelOrderAction(params, callback));
  },
  onCancelOrderAction: (params, callback, pageSize = consts.DEFAULT_PAGE_SIZE) => {
    dispatch(actions.cancelOrderAction(params, callback, pageSize, false));
  },
  onFetchOrderPaginateAction: (params) => {
    dispatch(actions.fetchOrderPaginateAction(params));
  },
  onClickOrderBookBuy: (params) => {
    dispatch(orderBookAction.clickOrderBookBuy(params));
  },
  onClickOrderBookSell: (params) => {
    dispatch(orderBookAction.clickOrderBookSell(params));
  },
  onCancelAllOrder: () => {
    dispatch(actions.cancelAllOrderAction());
  },
  onFetchIdOrderTrans: (params, callback) => {
    dispatch(actionsOrderTrans.fetchIdOrderTransactionsAction(params, callback));
  },
});

export const OpenOrderContainer = connect(mapStateToProps, mapDispatchToProps)(OpenOrderComponent);
export const OpenOrderExchangeContainer = connect(mapStateToProps, mapDispatchToProps)(OpenOrder);
export const OrderHistoryContainer = connect(mapStateToProps, mapDispatchToProps)(OrderHistoryComponent);
